import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../services/api'

// Cuarteleros / Maquinistas — el endpoint /api/operadores devuelve el array directo
// (igual que especialidades), así que el thunk retorna response.data y el reducer usa payload.
export const fetchOperadores = createAsyncThunk('operadores/fetchAll', async (_, { rejectWithValue }) => {
  try { const r = await api.get('/operadores'); return r.data }
  catch (e) { return rejectWithValue(e.response?.data?.mensaje || 'Error al obtener operadores') }
})

export const createOperador = createAsyncThunk('operadores/create', async (data, { rejectWithValue }) => {
  try { const r = await api.post('/operadores', data); return r.data }
  catch (e) { return rejectWithValue(e.response?.data?.mensaje || e.response?.data?.errores || 'Error al crear operador') }
})

export const updateOperador = createAsyncThunk('operadores/update', async ({ id, data }, { rejectWithValue }) => {
  try { const r = await api.put(`/operadores/${id}`, data); return r.data }
  catch (e) { return rejectWithValue(e.response?.data?.mensaje || e.response?.data?.errores || 'Error al actualizar operador') }
})

export const deleteOperador = createAsyncThunk('operadores/delete', async (id, { rejectWithValue }) => {
  try { await api.delete(`/operadores/${id}`); return { id } }
  catch (e) { return rejectWithValue(e.response?.data?.mensaje || 'Error al eliminar operador') }
})

const slice = createSlice({
  name: 'operadores',
  initialState: { operadores: [], loading: false, saving: false, error: null },
  reducers: { clearError: (s) => { s.error = null } },
  extraReducers: (b) => {
    b.addCase(fetchOperadores.pending, (s) => { s.loading = true; s.error = null })
      .addCase(fetchOperadores.fulfilled, (s, a) => { s.loading = false; s.operadores = Array.isArray(a.payload) ? a.payload : [] })
      .addCase(fetchOperadores.rejected, (s, a) => { s.loading = false; s.error = a.payload })
      .addCase(createOperador.pending, (s) => { s.saving = true; s.error = null })
      .addCase(createOperador.fulfilled, (s, a) => { s.saving = false; s.operadores.unshift(a.payload) })
      // Las mutaciones NO setean s.error: la página ya toastea el fallo en el catch del .unwrap()
      // (con detalle Joi). Setearlo acá disparaba además el useEffect(error) = doble toast.
      .addCase(createOperador.rejected, (s) => { s.saving = false })
      .addCase(updateOperador.pending, (s) => { s.saving = true; s.error = null })
      .addCase(updateOperador.fulfilled, (s, a) => { s.saving = false; const i = s.operadores.findIndex((o) => o.id === a.payload.id); if (i >= 0) s.operadores[i] = a.payload })
      .addCase(updateOperador.rejected, (s) => { s.saving = false })
      .addCase(deleteOperador.fulfilled, (s, a) => { s.operadores = s.operadores.filter((o) => o.id !== a.payload.id) })
      .addCase(deleteOperador.rejected, () => {})
  },
})

export const { clearError } = slice.actions
export default slice.reducer
